

<joi-nav-wrapper *ngIf="!!breakDays"
  class="days"
  [simple]="true"
  [menuItems]="menuItems"
  [publicStyle]="true"
  [menuMap]="menuMap"
  [selectedId]="selectedDay + ''" 
  (selectItem)="selectedDay = parseInt($event)"
></joi-nav-wrapper>

<ng-container *ngFor="let days_sessions of timeline; trackBy: trackByIndex; index as index">
  <div class="item" *ngIf="!breakDays || index === selectedDay">
    <div *ngFor="let session of days_sessions; first as first; last as last; index as index; trackBy: trackByIndex">
      <h3 class="group_date" [ngClass]="{extraSpacing: false && session.displayDate}" *ngIf="first && !(session.displayDate && timeline?.length === 1)">
        <span *ngIf="true || !session.displayDate">
          {{ session.displayDate ? session.displayDate : session.session_date === session.on_day ? 'Day '+session.on_day : (session.session_date | date:"EEEE d LLLL y")  }}
        </span>
      </h3>
      <publish-timeline-item
        [first]="first"
        [last]="last"
        [session]="session"
        [checking]="!!checkedSessionIds"
        [checked]="!!checkedSessionIds?.includes(session.id)"
        (onCheck)="toggleChecked(session.id)"
        [militaryTime]="!excludedFieldIds.includes('militaryTime')"
        [hideTimeZone]="excludedFieldIds.includes('showTimeZone')"
        [startingCollapseState]="excludedFieldIds.includes('collapseByDefault') ? 'expand' : 'collapse'"
        [joiEvent]="joiEvent"
        [programText]="session.program ? programTexts[session.program.id] : ''"
        [priorSession]="days_sessions[index-1]"
        [toggleSubject]="$toggleAll"
        [latterSession]="days_sessions[index+1]"
        [userSelectedTimezone]="userSelectedTimezone"
        [sponsorsCustomTitle]="sponsorsCustomTitle"
      >
    </publish-timeline-item>
    </div>
  </div>
</ng-container>
